import { ReactNode } from 'react';

interface LayersProps {
  children: ReactNode;
}

export const Layers = ({ children }: LayersProps) => {
  return <>{children}</>;
};
